import { INFANT } from '../../domain/age';

export const doGuestRequireBed = guest => guest.customerCategory !== INFANT;




// WEBPACK FOOTER //
// ./src/store/reservation/rules.js